import Vue from "vue";
import snackbar from "@/utils/snackbar";
import i18n from "@/utils/translations";

Vue.directive("copy", {
  bind: function (el, binding, vNode) {
    el.addEventListener("mouseenter", (e) => {
      const contentToCopy = el.innerHTML;
      let tooltip = document.createElement("div");
      tooltip = document.createElement("div");
      tooltip.setAttribute(
        "style",
        "line-height: normal;font-size:14px;height:32px;width: 80px; background-color: black; opacity: 0.5; color: white; text-align: center; border-radius: 4px; padding: 8px 24px 6px 24px; position: absolute; cursor:pointer; z-index:100"
      );
      tooltip.innerHTML = "Copy";
      el.appendChild(tooltip);
      el.setAttribute("style", "display: block;");
      el.addEventListener(
        "click",
        (event) => {
          event.stopImmediatePropagation();
          navigator.clipboard
            .writeText(contentToCopy)
            .then((resp) => {
              snackbar.success("Copying to clipboard was successful", false);
            })
            .catch((err) => {
              snackbar.error();
            });
        },
        false
      );
    });

    el.addEventListener(
      "mouseleave",
      (e) => {
        el.setAttribute("style", "");
        let child = el.lastElementChild;
        while (child) {
          el.removeChild(child);
          child = el.lastElementChild;
        }
      },
      false
    );
  },

  unbind: function (el, binding) {
    // Remove Event Listeners
    el.removeEventListener("mouseover", this);
    el.removeEventListener("mouseleave", this);
  },
});
